module.exports = {"id":"164529","name":"Drew Moor","rating":"73","photo":"./data/images/photos/3/164529.png","club":{"name":"Toronto FC","logo":"./data/images/clubs/TorontoFC.png"},"positions":["DC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DrewMoor0.json
// module id = 1150
// module chunks = 0